// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { pnet as basePnetTheme } from "@stepstone-genesis/design-tokens";
var pnet = extendBaseTheme("pnet", basePnetTheme);
export {
  pnet
};
